import MainLayout from '../../../commons/layout/MainLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import ROUTERS from '../../../commons/constans/router';
import HeaderHs2 from '../../../commons/components/Header/headerHs2';
import Slider from '../../../commons/components/Slider';
import {STEPS} from '../../../commons/constans/stepVideo';
import ButtonComponent from '../../../commons/components/Forms/ButtonComponent';
import RenderBannerComponent from '../../../commons/components/Banner';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import PopupComponent from '../../../commons/components/Popup/PopupComponent';
import DialogComponent from '../../../commons/components/Modal/DialogComponent';
import moment from 'moment';
import { TIME_ZONE } from '../../../commons/constans/moment';
import API, { ROUTES } from '../../../commons/api/api';
import { useUser } from '../../../commons/customHooks/Banner';
import { getCurrentUser, updateSuccess } from '../../Account/redux/actions';
import SkeletonLoadingComponent from '../../../commons/components/SkeletonLoading';
import Loading from '../../../commons/components/Loading';
import { getDataLocalStorage, setLocalStorage } from '../../../utils/helpers';
import { updateVideoMergeErrorRequest, videoPaymentClearState } from '../redux/actions';
import { ReactComponent as ImgStep1 } from '../../../assets/images/img_video_step_1.svg';
import { ReactComponent as ImgStep2 } from '../../../assets/images/img_video_step_2.svg';
import { ReactComponent as ImgStep3 } from '../../../assets/images/img_video_step_3.svg';
import { ReactComponent as ImgStep4 } from '../../../assets/images/img_video_step_4.svg';
type Props = {
  banners: Object,
  albums: Object,
  userInfo: Object,
  updateExplainVideoPopup: Function,
  getTimeVideoRenderRequest: Function,
  coupon:Object,
  isProcessing: Boolean,
  isProcessingDel: Boolean,
  videoRender: Array
};

const VideoMessageMakerComponent = ({ banners, albums, userInfo, getTimeVideoRenderRequest, videoRender, isProcessingVideoRender, updateExplainVideoPopup, coupon , isProcessing, isProcessingDel}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [popup, setPopup] = useState(false);
  const [isVideoRendering, setIsVideoRendering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowVideoRendering, setIsShowVideoRendering] = useState(false);
  const { user } = useUser();

  const handleLeftClick = () => {
    //clear step
    // dispatch(videoPaymentClearState());
    if(coupon?.id) {
      navigate(ROUTERS.GIFTBOX_POINT+'?type=coupon')
    }else {
      navigate(ROUTERS.HOME);
    }
  };


  useEffect(() => {
    dispatch(videoPaymentClearState());
    setIsLoading(true);
    let param = {
      relation: ['characterPose', 'videoMessageTemplete']
    }
    console.log('getTimeVideoRenderRequest');
    // dispatch(getTimeVideoRenderRequest(param));
  }, [])

  useEffect(() => {
    console.log(videoRender, 'videoRender');
    if (videoRender && videoRender.length > 0) {
      if (!videoRender[0].file_id) {
        setIsVideoRendering(true);
        // window.nativeCallCheckMergeVideo(user?.id || null)
      }else{
        setIsVideoRendering(false);
        setIsShowVideoRendering(false);
      }
    }else{
      setIsVideoRendering(false);
      setIsShowVideoRendering(false);
    }
  }, [videoRender, isProcessingVideoRender])


  useEffect(() => {
    scrollTo(0, 0);
    let dateTimeCurrent = moment().tz(TIME_ZONE).format('l');
    // check has explain_video_popup && explain_video_popup === dateTimeCurrent => false
    // if (user.explain_video_popup && user.explain_video_popup == dateTimeCurrent) {
    //   setPopup(false);
    // }else{
    //   setPopup(true);
    // }

    let data = {
      name: 'useVideoMaker',
      userId: userInfo?.id || null
    };
    let getData = getDataLocalStorage(data);
    if (getData) {
      setPopup(false)
    }else{
      setPopup(true)
    }

  }, []);

  const handleClosepopup = () => {
    setPopup(false);
  }

  const handleNotShowInDay = () => {
    // let data = moment().tz(TIME_ZONE).format('l');
    // updateExplainPopup(data);
    setPopup(false);
    let dataLocalStorage = {
      userId: userInfo.id,
      name: 'useVideoMaker'
    }
    setLocalStorage(dataLocalStorage);
  }

  const updateExplainPopup = (data) => {
    var formData = new FormData();
    formData.append("explain_video_remove", data);

    // dispatch(updateExplainVideoPopup(formData))
    API({
        method: "post",
        url: ROUTES.API_UPDATE_AUTH_ME,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
    }).then(res => {
        let data = res.data.data;
        dispatch(updateSuccess(data));
    }).catch(e => {
        let error =  e.response;
    })
  }

  const demoMerge = () => {
    let data = {
      "audio": "http://sphokidz.dev-enjoyworks.com:9003/output/1685511027830.eab655543f1743eb985624466ff50871/output-audio.mp3",
      "video": "http://sphokidz.dev-enjoyworks.com:9003/video/chuchu/template3/2.mp4"
    }
    window.nativeCallMergeVideo(data);
  }

  const goToStepOne = () => {
    if (isVideoRendering) {
      setIsShowVideoRendering(true);
    }else{
      navigate(ROUTERS.VIDEO_MESSAGE_MAKER_STEP_PATH(STEPS.ONE));
    }
  };

  const handleVideoDetail = (id) => {
    navigate(ROUTERS.VIDEO_DETAIL_PATH(id), {state: {prevPath: 'prevPath', type: ROUTERS.VIDEO_MESSAGE_MAKER}});
  };

  const renderVideoMessage = () => {
    if (albums && albums.video_message && albums.video_message.length > 0) {
      return albums.video_message.map((item, idx) => {
        return (
          <div className="item" key={idx} onClick={() => handleVideoDetail(item.id)}>
            <div className="img" >
              <span>
                <img src="/images/icon_play-btn.svg" alt="hover" />
              </span>
              {
                item.video_message?.thumbnail &&  (<img
                  className="message-maker-img"
                  src={item?.photo_url || ''}
                  alt=""
                />)
              }
             
            </div>
            <div className="description text-truncate">{item?.video_message?.title || ''}</div>
          </div>
        )
      })
    } else {
      return (
        <>
        </>
      );
    }
  };

  const handleClose = () => {
    setIsShowVideoRendering(false);
    if (videoRender && videoRender.length > 0) {
      if (!videoRender[0]?.file_id) {
        let dataMerge = {
          name: videoRender[0]?.child_name || '',
          template: videoRender[0]?.video_message_templete.code || 2,
          character: videoRender[0]?.character_pose.child_name === '차탄' ? 'chatan' : 'chuchu',
          video_id: videoRender[0]?.id || null,
          user_id: user?.id || null
        }
        console.log(194, dataMerge);
        //delete id_popup_merge
        window.localStorage.removeItem('id_popup_merge');
        var formData = new FormData();
        formData.append("video_merge_error", 0);
        dispatch(updateVideoMergeErrorRequest(formData));
        navigate(ROUTERS.VIDEO_COMPLETED, {state: {
          dataMerge 
        }});
      }
    }
  }

  console.log(isVideoRendering, 'isVideoRendering');
  return (
    <MainLayout
      pageID={'video-message-marker'}
      activeNav={'VIDEO'}
      displayBottomNav={true}
    >
      <HeaderHs2
        labelRight={false}
        labelLeft={true}
        title="영상 편지"
        handleLabelLeft={() => handleLeftClick()}
      />
      <div className="content">
        <div className="content-video__top">
          {/* <div className='message-video'>
            <img src="/images/img_back_video.svg" alt="background" />
            <RenderBannerComponent banners={banners} />
          </div> */}
          
          <div className="slider">
            <h2>
              <span>{userInfo?.nickname || ''}</span>님의 제작영상
            </h2>
            <div className="slider_video">

              {
                isProcessing || isProcessingDel ? <div className=''>
                    <SkeletonLoadingComponent height={150} type={'video'} width={280} />
                  </div> : 
                  albums &&
                  albums.video_message &&
                  albums.video_message.length > 0 ? (
                    <Slider
                      slidesPerView={1.15}
                      spaceBetween={15}
                      pagination={false}
                      // loop
                    >
                      {renderVideoMessage()}
                    </Slider>
                  ) : (
                    <>
                      <div className="no-video-created">
                        아직 제작된 영상이 없어요  <br />
                        영상 편지로 우리아이에게 소중한 추억을 만들어주세요
                      </div>
                    </>
                  )
              }
             
            </div>
          </div>
        </div>
        <div
          className="content-video__learn"
          style={{ backgroundImage: "url('/images/img_back_video.svg')" }}
        >
          <h3>영상 제작 방법을 알아볼까요?</h3>
          <p className="mb-0">우리 아이를 위한 영상을 제작해보세요!</p>
        </div>
        <div className="content-video__bottom">
          <div className="step">
            <ul>
              <li>
                <div className="img">
                  <ImgStep1 />
                </div>
                <div className="description">
                  <span>STEP1</span>
                  <h4>원하는 캐릭터 선택</h4>
                  <p>
                    아이가 좋아하는 만화를 선택하고, 만화속 <br /> 
                    캐릭터를 선택할 수 있습니다.{' '}
                  </p>
                </div>
              </li>
              <li>
                <div className="img">
                  <ImgStep2 />
                </div>
                <div className="description">
                  <span>STEP2</span>
                  <h4>이름과 메세지 선택</h4>
                  <p>
                  아이의 이름을 입력하고 아이에게 들려줄<br />
                  메세지를 입력하면 캐릭터가 읽어줍니다.{' '}
                  </p>
                </div>
              </li>
              <li style={{paddingRight: 30}}>
                <div className="img">
                  <ImgStep3 />
                </div>
                <div className="description">
                  <span>STEP3</span>
                  <h4>메세지확인</h4>
                  <p>
                    우리 아이에게 전달될 메세지가 잘 입력 <br />
                    되었는지 확인할 수 있습니다.
                    {/* 우리 아이에게 전달될 메세지가 잘 입력 <br />
                    되었나확인할 수 있습니다. */}
                  </p>
                </div>
              </li>
              <li>
                <div className="img">
                  <ImgStep4 />
                </div>
                <div className="description">
                  <span>STEP4</span>
                  <h4>결제하기</h4>
                  <p>
                    결제가 완료되면 영상제작이 시작됩니다. <br />
                    2회권으로 결제시엔 1,000원 할인 혜택!
                  </p>
                </div>
              </li>
              <li>
                <div className="img">
                  <img src="/images/img_video_step_5.svg" alt="step5" />
                </div>
                <div className="description">
                  <span>STEP5</span>
                  <h4>앨범에서 영상확인</h4>
                  <p>
                    우리 아이만을 위한 영상 제작이 완료되면 <br />
                    앨범에서 확인할 수 있습니다.{' '}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="button">
            
            {/* <ButtonComponent
              label={`Demo Merge Video`}
              customClass="btn btn-default"
              handleClick={demoMerge}
              type={`button`}
            />
            <br /> */}
            <ButtonComponent
              label={`영상 만들기`}
              customClass="btn btn-default"
              handleClick={goToStepOne}
              type={`button`}
              disabled={isShowVideoRendering}
            />
          </div>
        </div>
            
      </div>
      {
        isProcessingVideoRender && <Loading />
      }
      
      {/* <PopupComponent 
          id={``}
          show={popup}
          handleClose={handleClosepopup}
          children={``}
          scrollable={``}
          title={`영상편지란?`}
        >
          <div>
            아이가 좋아하는 캐릭터로 영상을 만들어
            특별한 편지를 선물해 보세요.
          </div>
        </PopupComponent>     */}
        <DialogComponent 
          id={`js-show-popup`} 
          children={``} 
          show={popup} 
          title={`영상편지란?`} 
          closeBtn={`확인`}
          customBtn={`하루보지않음`}       
          handleCustom={handleNotShowInDay}  
          handleClose={handleClosepopup}
          className={`popup-explan-message`}
        >
          <div className="content-dialog-time">
            <div className='text'>
            아이가 좋아하는 캐릭터로 영상을 만들어<br />
            특별한 편지를 선물해 보세요.<br />
            </div>
            <div className='img'>
              <img src="/images/video_banner.png" alt="" />
            </div>
            <div className='text'>
              다양한 캐릭터와 노래를 통해<br />     
              캐릭터가 아이에게 특별한 추억을 선물합니다.<br />
            </div>
          
          </div>
        </DialogComponent>

        <DialogComponent 
          id={`js-video-render`} 
          children={``} 
          show={isShowVideoRendering} 
          title={`알림`} 
          closeBtn={`확인`}
          handleClose={handleClose}
          className={``}
        >
          <div className="content-dialog-video-rendering">
            <div className='text'>
              제작이 중단된 영상 편지가 존재합니다.<br />
              계속해서 제작 진행하시겠습니까?
            {/* <label className='text-push'>
              제작이 완료되면 push로 알려드립니다.
            </label> */}
            </div>
          </div>
        </DialogComponent>
    </MainLayout>
  );
};

export default VideoMessageMakerComponent;
